<template>
	<div class="test">
		<div slot="body">
			<sBox title="Filtrar Exames">
				<div slot="tools">
					<div class="box-excel-export">
						<aBtn
							action="private-save-exams2"
							@click="$refs.modalExcel.open()"
							text="Importar Excel"
							icon="plus"
							size="sm"
							type="info"
							class="btn-export"
						/>

						<aBtn
							@click="handleConvertTableToXLS()"
							text="Exportar Excel"
							icon="minus"
							size="sm"
							type="info"
							class="btn-import"
						/>
					</div>
				</div>
				<div class="row" slot="body">
					<div class="col-sm-2">
						<span>CPF</span>
						<input
							v-mask="'###.###.###-##'"
							v-model="filter.CPF"
							@input="fxFilter('CPF', $event.target.value)"
							type="text"
							class="form-control"
							placeholder="999.999.999-99"
						/>
					</div>
					<div class="col-sm-3">
						<span>Nome</span>
						<input
							v-model="filter.nome"
							@input="fxFilter('nome', $event.target.value)"
							type="text"
							class="form-control"
							placeholder="NOME"
						/>
					</div>

					<div class="col-sm-2">
						<span>Resultado</span>
						<input
							v-model="filter.resultado"
							@input="fxFilter('resultado', $event.target.value)"
							type="text"
							class="form-control"
							placeholder="RESULTADO"
						/>
					</div>
					<div class="col-sm-2">
						<span>Tipo de teste</span>
						<input
							v-model="filter.tipoTeste"
							@input="fxFilter('tipoTeste', $event.target.value)"
							type="text"
							class="form-control"
							placeholder="TIPO DE TESTE"
						/>
					</div>

					<div class="col-sm-3">
						<span>Intervalo</span>
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-calendar"></i>
							</span>
							<div class="form-control" id="datepicker-trigger">
								{{ fDate(dateOne) }} - {{ fDate(dateTwo) }}
							</div>
						</div>
						<div class="cnt-airbnb">
							<div class="airbnb">
								<AirbnbStyleDatepicker
									id="wrapper-date"
									trigger-element-id="datepicker-trigger"
									:mode="'range'"
									:months-to-show="2"
									:date-one="dateOne"
									:date-two="dateTwo"
									@apply="fxFilter('dataTeste')"
									style="
										position: none;
										box-shadow: rgba(0, 0, 0, 0.25) 0px 54px
												55px,
											rgba(0, 0, 0, 0.12) 0px -12px 30px,
											rgba(0, 0, 0, 0.12) 0px 4px 6px,
											rgba(0, 0, 0, 0.17) 0px 12px 13px,
											rgba(0, 0, 0, 0.09) 0px -3px 5px;
									"
									:fullscreen-mobile="true"
									@date-one-selected="
										(val) => {
											dateOne = val;
										}
									"
									@date-two-selected="
										(val) => {
											dateTwo = val;
										}
									"
								/>
							</div>
						</div>
					</div>
				</div>
			</sBox>

			<br />

			<div class="box-excel-export">
				<aBtn
					action="private-save-exams"
					@click="$refs.modal.open()"
					text="Exames"
					icon="plus"
					size="sm"
					type="success"
				/>
			</div>

			<br />
			<sTable
				ref="tab"
				actionRead="private-read-exams"
				actionDelete="private-delete-exams"
				:labels="labels"
				:actions="actions"
				:tags="tags"
				:functions="functions"
				@comissao="(data) => $refs.modal2.open(data)"
				@edit="(data) => $refs.modal.open(data)"
			/>
		</div>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" :examsData="examsData" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import fDate from 'js/date';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import WBS from 'js/http';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	import moment from 'moment';

	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroExames',
		components: { sTable, sBox, modal, aBtn, modal2, fDate, WBS },

		data() {
			let iniData = new Date();
			iniData.setMonth(iniData.getMonth() - 10);

			let hoje = new Date();
			hoje.setDate(hoje.getMonth() + 5);
			return {
				CPF: '',
				nome: '',
				dateOne: iniData,
				dateTwo: hoje,

				exams: [],
				labels: [
					{ data: 'p.CPF', label: 'CPF/ID', main: true },
					{ data: 'p.nome', label: 'Colaborador', main: true },
					{ data: 'e.tipoTeste', label: 'Tipo de teste', main: true },
					{ data: 'laboratorio', label: 'Laboratório', main: true },
					{ data: 'diaTeste', label: 'Data teste', main: true },
					{ data: 'horaTeste', label: 'Hora teste', main: true },
					{ data: 'e.resultado', label: 'Resultado', main: true },
					{
						data: 'p.dataNasc',
						label: 'Data Nascimento',
						main: true,
					},
					{ data: 'anexo', label: 'Anexo', main: true },
				],
				actions: ['delete', 'edit'],
				functions: [
					{
						cod: 'anexo',
						fx: (e) => {
							if (e)
								return `<a class='btn-xs button-link'  target="_blank"  href='${e}'>
              <i class='fa fa-eye'></i>
            </a>

          `;
						},
					},
					{
						cod: 'p.CPF',
						fx: (val) => {
							return val
								.toString()
								.replace(
									/(\d{3})(\d{3})(\d{3})(\d{2})/g,
									'\$1.\$2.\$3\-\$4'
								);
						},
					},
					{
						cod: 'diaTeste',
						fx: (val) => {
							return moment(val).format('DD/MM/YYYY');
						},
					},
					{
						cod: 'horaTeste',
						fx: (val) => {
							return moment(val).format('HH:mm');
						},
					},
				],
				examsData: '',

				filter: {
					nome: '',
					CPF: '',
					resultado: '',
					tipoTeste: '',
				},
			};
		},
		methods: {
			fDate(data, mask = 'DD xmxs') {
				let date = new Date(data);
				date.setDate(date.getDate() + 1);
				return fDate(date, mask);
			},
			fxFilter(col, val) {
				let f = [];

				if (this.filter.CPF != '')
					f.push(
						`p.CPF like '%${this.filter.CPF.replace(
							/[^\w\s]/gi,
							''
						)}%'`
					);

				if (this.filter.nome != '')
					f.push(`LOWER(p.nome) like LOWER('%${this.filter.nome}%')`);

				if (this.filter.resultado != '')
					f.push(`e.resultado like '%${this.filter.resultado}%'`);

				if (this.filter.tipoTeste != '')
					f.push(`e.tipoTeste like '%${this.filter.tipoTeste}%'`);

				if (this.filter.dataTeste != '')
					f.push(
						` ( dataTeste BETWEEN '${this.fDate(
							this.dateOne,
							'YY-MM-DD'
						)}' and '${this.fDate(this.dateTwo, 'YY-MM-DD')}' ) `
					);

				f = f.join(' and ');

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},

			loadExams() {
				const testParms = {
					pager: {
						page: '0',
						qnt: '9999999',
					},
				};

				WBS.send('private-read-exams', testParms, async (resp) => {
					this.examsData = JSON.parse(
						JSON.stringify(resp.data.table)
					);

					// console.log(this.examsData)

					var rows = JSON.parse(JSON.stringify(resp.data.table));

					this.exams = await this.handleNormalizeExamsKeys(rows);
					return rows;
				});
			},

			handleNormalizeExamsKeys(examsData) {
				let exams = examsData;

				let normalizedExams = [];

				exams.map((exam) => {
					const handleSetDateYearAndTime = (e) =>
						this.handleSetDateYearAndTime(e);
					const handleChangeKey = (e) => this.handleChangeKey(e);

					Object.keys(exam).map(function (oldExamKey, label) {
						const newExamKey =
							handleChangeKey(oldExamKey) || oldExamKey;

						let newexamValue = exam[oldExamKey];

						if (
							newExamKey == 'DATA_DO_TESTE' ||
							newExamKey == 'DATA_DO_RESULTADO'
						) {
							newexamValue = handleSetDateYearAndTime(
								exam[oldExamKey]
							);
						}

						exam[newExamKey] = newexamValue;

						if (newExamKey != oldExamKey) delete exam[oldExamKey];

						if (oldExamKey == 'tempoResultadoFormatado')
							delete exam[oldExamKey];
					});

					const orderedExam = Object.keys(exam)
						.sort()
						.reduce((obj, key) => {
							obj[key] = exam[key];
							return obj;
						}, {});
					/*
            1 - formatar ele na ordem especifica
            2 - criar o formattedExam, com a ordem certa
            3 - merge nos dois
            */

					// obj <- propriedades de exam
					const examOrder = {
						EMPRESA: 0,
						'': '',
						NOME: '',
						CARGO: '',
						SEÇÃO: '',
						FROTA: '',
						DATA_DE_NASCIMENTO: '',
						IDADE: '',
						TIPO_DO_TESTE: '',
						LOCAL_DO_TESTE: '',
						DATA_DO_TESTE: '',
						LABORATÓRIO: '',
						PARCEIRO: '',
						DATA_DO_RESULTADO: '',
						TEMPO_DE_ANÁLISE: '',
						RESULTADO: '',
						MUNICÍPIO: '',
						ESTADO: '',
						'RG/PASS': '',
						CPF: '',
					};

					Object.keys(examOrder).map(function (key, value) {
						examOrder[key] = orderedExam[key];
					});

					normalizedExams.push(examOrder);
				});

				return normalizedExams;
			},

			handleSetDateYearAndTime(date) {
				var data = new Date(date),
					dia = data.getDate().toString().padStart(2, '0'),
					mes = (data.getMonth() + 1).toString().padStart(2, '0'), //+1 pois no getMonth Janeiro começa com zero.
					ano = data.getFullYear(),
					horas = `0${data.getHours()}`.slice(-2),
					minutos = `0${data.getMinutes()}`.slice(-2);

				return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
			},

			handleChangeKey(key) {
				switch (key) {
					case 'cargo':
						return 'CARGO';

					case 'CPF':
						return 'CPF';

					case 'dataNasc':
						return 'DATA_DE_NASCIMENTO';

					case 'resultado':
						return 'RESULTADO';

					case 'empresa':
						return 'EMPRESA';

					case 'estado':
						return 'ESTADO';

					case 'navio.frota':
						return 'FROTA';

					case 'idade':
						return 'IDADE';

					case 'parceiro':
						return 'PARCEIRO';

					case 'nome':
						return 'NOME';

					case 'navio':
						return 'SEÇÃO';

					case 'laboratorio':
						return 'LABORATÓRIO';

					case 'municipio':
						return 'MUNICÍPIO';

					case 'RG':
						return 'RG/PASS';

					case 'dataResultado':
						return 'DATA_DO_RESULTADO';

					case 'localTeste':
						return 'LOCAL_DO_TESTE';

					case 'dataTeste':
						return 'DATA_DO_TESTE';

					case 'tempoResultado':
						return 'TEMPO_DE_ANÁLISE';

					case 'tipoTeste':
						return 'TIPO_DO_TESTE';

					default:
						return key;
				}
			},

			handleConvertDate(dateStr) {
				let date = new Date(dateStr);
				let options = {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
				};
				date.toLocaleDateString('pt-BR', options);
			},

			handleConvertTableToXLS() {
				const data = this.exams;
				const filename = 'Dados dos Exames.xlsx';
				var ws = XLSX.utils.json_to_sheet(data);
				var wb = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(wb, ws, 'People');
				XLSX.writeFile(wb, filename);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento de Exames', '']);

			this.loadExams();
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px !important;
	}

	.btn-export {
		filter: saturate(1.5);
	}

	.table,
	.table-striped,
	.table-hover {
		max-width: 100% !important;
		overflow-x: scroll !important;
		overflow-y: clip !important;
	}

	[data-v-4c24c5d2] [data-v-4481e0c6] {
		overflow-x: scroll !important;
		overflow-y: clip !important;
	}

	.cnt-pager[data-v-30c8dc48] {
		/*overflow-y: clip;*/
		overflow: initial !important;
	}

	[data-v-4fc2e1b0] {
		max-width: 100%;
		width: 100% !important;
		overflow-x: scroll;
		overflow-y: clip;
	}
	/*


.btn-import: hover{
  background-color: #1e5bd3
}


.btn-export: hover{
  background-color: #81a9ff;
}
*/

	.button-link:hover {
		filter: contrast(120%);
	}

	.button-link {
		text-decoration: none !important;
		display: inline-block;

		text-transform: none;

		background-color: #e97f59 !important;

		color: white !important;

		font-size: 14px;

		-webkit-box-shadow: none;
		box-shadow: none;

		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background-image: none;
		/* border: 1px solid #ccc; */
		border-radius: 4px;
	}
	.airbnb-style-datepicker-wrapper {
		position: absolute !important;
		width: 600px !important;
		z-index: 100 !important;
		top: 41px !important;
		right: 0px !important;
		left: 0px !important;
	}
	div.datepicker-inner-wrapper {
		margin: 3px 0 0 0 !important;
	}
	.airbnb {
		position: absolute;
		right: 601px;
		top: -40px;
	}
	.cnt-airbnb {
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/exames/index.vue